import { useTranslation } from "react-i18next";

import DefaultActions from "./DefaultActions";

export default function CourseActions({ onPrimary, menuActions, row }) {
	const { t } = useTranslation();

	return (
		<DefaultActions
			ActionsList={menuActions}
			onPrimary={onPrimary}
			primaryText={t("commands.resume")}
			row={row}
			menuButtonTestId={`course-menu-button-${row.id}`}
		/>
	);
}
